<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="card-footer"
    :class="cn('flex min-h-17.5 items-center justify-between gap-3 border-t border-default px-5 py-4', props.class)"
  >
    <slot />
  </div>
</template>
